// extracted by mini-css-extract-plugin
module.exports = {"notificationsPopover__noContent":"styles_notificationsPopover__noContent__3F6xe"};